export enum TranCode {
  ERW = 'ERW',
  SRW = 'SRW',
  STU = 'STU',
  ERD = 'ERD',
  SRD = 'SRD',
  QRS = 'QRS'
}
